import { useEffect } from 'react';

import { IframeOpener } from '../../vanillaComponent/iframe-opener';
import { MultiCTA } from '../../vanillaComponent/MultiCTA';

function MultiWidget() {
  useEffect(() => {
    const openIframeContainer = document.getElementById('open-iframe');

    if (openIframeContainer && !openIframeContainer.querySelector('[id^="open-iframe-button"]')) {
      const widgetData = {
        token: 'THB3R1lNZmZodlpBNHg1TDVrellOMDZl',
        type: 'button',
        version: '1.0',
        module: 'multi-cta', // 'credit-score',
      };

      // new IframeOpener(widgetData).render(openIframeContainer);
      new MultiCTA(widgetData).render(openIframeContainer);
    }

    // If you need to clean up or perform actions when the component is unmounted,
    // you can return a cleanup function from the useEffect.
    return () => {
      // Cleanup logic (if needed)
    };
  }, []); // Empty dependency array means this effect runs only once

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <p>VIN: KNDPUCAF3P7085487</p>
        <div id='open-iframe'></div>
      </div>
    </>
  );
}

export default MultiWidget;
